import { useTranslation } from "react-i18next";
import { GoArrowUp, GoArrowDown } from "react-icons/go";

export default function ScanMetricCards({
    icon,
    value,
    label,
    trend,
    trendValue,
    onClick
}) {
    const { t } = useTranslation();

    const hasTrend = trend != null;
    const hasInfo = trendValue != null;
    const isUp = trend === "up";

    return (
        <div 
            className="scan-metric-cards"
            onClick={onClick}
            style={{ cursor: onClick ? 'pointer' : 'default' }}
            role={onClick ? "button" : undefined}
            tabIndex={onClick ? 0 : undefined}
        >
            <div className="scan-metric-cards-logo">
                {icon}
            </div>

            <div className="scan-metric-cards-content">
                <h3 className="scan-metric-cards-content-value">
                    {value}
                </h3>

                <p className="scan-metric-cards-content-label">
                    {t(label)}
                </p>

                {hasInfo && (
                    <div className="scan-metric-cards-content-indicator">

                        {hasTrend && (
                            <div
                                className="scan-metric-cards-content-indicator-level"
                                style={{
                                    background: isUp
                                        ? "var(--danger-status-color)"
                                        : "var(--success-status-color, #2ecc71)"
                                }}
                            >
                                {isUp
                                    ? <GoArrowUp />
                                    : <GoArrowDown />
                                }
                            </div>
                        )}

                        <p className="scan-metric-cards-content-indicator-label">
                            {trendValue}
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
}